import {keyBy, omit} from 'lodash';
import {RECEIVE_COURSES, DELETE_COURSES} from 'portfolio/actions/courses';

export const bulkEntryCoursesReducer = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_COURSES: {
      return {...state, ...keyBy(action.courses, '_id')};
    }
    case DELETE_COURSES:
      return omit(state, action.ids);
    default:
      return state;
  }
};
